<template>
  <div
    class="copy-btn tooltip"
    @mouseover="copyIconColor = '#f2f2f2'"
    @mouseleave="copyIconColor = '#cccccc'"
  >
    <span class="tooltip-text">{{
      copied ? copiedTooltipText : copyTooltipText
    }}</span>
    <div v-if="copied" :class="{ 'zoom-bounce': copied }">
      <vs-icon
        v-if="copied"
        icon-pack="feather"
        icon="icon-check"
        size="14px"
        :style="{ color: copiedIconColor }"
      ></vs-icon>
    </div>
    <div v-else>
      <vs-icon
        icon-pack="feather"
        icon="icon-copy"
        size="14px"
        :style="{ color: copyIconColor }"
      ></vs-icon>
    </div>
  </div>
</template>

<script>
export default {
  name: "copy-to-clipboard",
  props: {
    copyTooltipText: { type: String, default: "コピー" },
    copiedTooltipText: { type: String, default: "コピーしました！" },
  },
  data() {
    return {
      copied: false,
      tooltipText: "",
      copyIconColor: "#7d7d7d",
      copiedIconColor: "#00ff7f",
    };
  },
  methods: {
    async copyToClipboard(textValue) {
      await navigator.clipboard.writeText(textValue);
      this.copied = true;
      setTimeout(() => {
        this.copied = false;
      }, 1500);
    },
  },
};
</script>

<style lang="scss" scoped>
.copy-btn {
  cursor: pointer;
}

.zoom {
  transition-duration: 0.4s;
}

.c-btn.big:hover {
  transform: scale(1.1);
}

.tooltip {
  position: relative;
  cursor: pointer;
}

.tooltip-text {
  opacity: 0;
  visibility: hidden;
  position: absolute;
  left: 50%;
  transform: translateX(-50%) translateY(10px);
  top: -30px;
  display: inline-block;
  padding: 5px;
  white-space: nowrap;
  font-size: 0.8rem;
  line-height: 1.3;
  background: #333;
  color: #f2f2f2;
  border-radius: 3px;
  transition: opacity 0.2s ease-out, transform 0.2s ease-out;
}

.tooltip:hover .tooltip-text {
  opacity: 1;
  visibility: visible;
  transform: translateX(-50%) translateY(0);
}

.zoom-bounce {
  animation: zoomBounce 0.6s ease forwards;
}

@keyframes zoomBounce {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.3);
  }
  70% {
    transform: scale(0.9);
  }
  100% {
    transform: scale(1);
  }
}
</style>
